import React, { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

const GEO_URL = "/india_states.geojson";
const NAME_FIX = { "Dadra and Nagar Haveli and Daman and Diu": "Dadra & Nagar Haveli" };

export const geoStateName = (geo) => NAME_FIX[geo.properties.ST_NM] || geo.properties.ST_NM;

function fillFor(count, max, selected) {
  if (selected) return "hsl(160 84% 17%)";
  if (!count) return "hsl(150 15% 90%)";
  const t = Math.min(1, count / Math.max(max, 1));
  return `hsl(160 70% ${78 - t * 40}%)`;
}

export const IndiaMap = ({ counts, selected, onSelect }) => {
  const [hover, setHover] = useState(null);
  const max = Math.max(0, ...Object.values(counts));

  return (
    <div className="relative" data-testid="india-map">
      <ComposableMap projection="geoMercator" projectionConfig={{ center: [82.8, 22.5], scale: 1000 }} width={600} height={680} style={{ width: "100%", height: "auto" }}>
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geoStateName(geo);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  data-testid={`map-state-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  onClick={() => onSelect(selected === name ? null : name)}
                  onMouseEnter={() => setHover(name)}
                  onMouseLeave={() => setHover(null)}
                  onTouchEnd={() => setHover(null)}
                  fill={fillFor(counts[name], max, selected === name)}
                  stroke="#fff"
                  strokeWidth={0.6}
                  style={{
                    default: { outline: "none", transition: "fill 200ms" },
                    hover: { outline: "none", fill: "hsl(160 84% 39%)", cursor: "pointer" },
                    pressed: { outline: "none" },
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
      {hover && (
        <div className="absolute top-3 left-3 rounded-lg bg-white/90 backdrop-blur border px-3 py-2 text-sm shadow-sm pointer-events-none" data-testid="map-tooltip">
          <div className="font-display font-semibold text-primary">{hover}</div>
          <div className="text-xs text-muted-foreground">{counts[hover] || 0} listing(s)</div>
        </div>
      )}
    </div>
  );
};
